import { Button, FileInput, Group, LoadingOverlay, Modal, Stack, Text } from '@mantine/core';
import { IconFileUpload } from '@tabler/icons-react';
import useManualFileUpload from '../hooks/useManualFileUpload';

export default function ManualFileUploadModal(props: { opened: boolean; onClose: () => void }) {
  const { opened, onClose } = props;
  const { file, isLoading, onClickUpload, setFile, resetStates } = useManualFileUpload({
    onClose,
  });

  const handleClose = () => {
    if (isLoading) return;
    resetStates();
    onClose();
  };

  return (
    <Modal title="파일 업로드" opened={opened} onClose={handleClose} centered>
      <Stack style={{ minWidth: 0 }}>
        <FileInput
          label="매뉴얼 업로드"
          placeholder="매뉴얼을 등록해주세요."
          withAsterisk
          leftSection={<IconFileUpload size={16} />}
          styles={{
            root: {
              minWidth: 0,
            },
            input: {
              minWidth: 0,
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              overflowWrap: 'anywhere',
            },
          }}
          value={file}
          onChange={setFile}
          accept={'.pdf'}
        />
        <Stack gap="xs" mt={4} style={{ minWidth: 0 }}>
          <Text size="xs" fw={600}>
            ※유의사항
          </Text>
          <Text size="xs" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
            • 업로드 시 학습 중단은 불가합니다.
          </Text>
          <Text size="xs" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
            • AI가 인식하기 어려운 내용은 학습되지 않을 수 있습니다.
          </Text>
        </Stack>
        <Group justify="center" mt="sm">
          <Button variant="outline" onClick={onClose}>
            취소
          </Button>
          <Button onClick={onClickUpload}>저장</Button>
        </Group>
      </Stack>
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
        overlayProps={{ radius: 'sm', blur: 1 }}
        loaderProps={{ color: 'primary.5' }}
      />
    </Modal>
  );
}
